<div id="dialog">
  <div>
    <strong>{{ "name" | translate }}:</strong>
    {{ data.student.name }}
  </div>
  <div>
    <strong>{{ "country" | translate }}:</strong>
    {{ data.student.country }}
  </div>
  <div>
    <strong>{{ "languages" | translate }}:</strong>
    {{ data.student.languages.join() }}
  </div>
  <div>
    <strong>{{ "why-want-study" | translate }}:</strong>
  </div>
  <div>
    {{ "goal-joining-student-" + data.student.goal_joining | translate }}
  </div>
</div>
